import { AbstractDataClass, column } from '@/helpers/AbstractDataClass';
import { Region } from '@/store/region/types';

export interface User {
  _id?: string;
  email?: string;
  username?: string;
  type?: boolean;
  regions?: Array<Region>;
  profile?: string;
}

export interface UserState {
  user?: User;
  dataUser?: DataUser[];
}

export class DataUser extends AbstractDataClass<DataUser> implements User {
  public _id: string;

  @column({
    label: 'Nom de l\u0027utilisateur',
    placeholder: 'Nom de l\u0027utilisateur',
    isSearchable: true,
    isArray: false,
  })
  public username?: string;

  @column({
    isNotPut: true,
    label: 'Email de  l\u0027utilisateur',
    placeholder: 'Email de  l\u0027utilisateur',
    isArray: false,
    isSearchable: true,
  })
  public email?: string;

  @column({
    isNotPut: true,
    label: 'Avec pouvoir',
    isCheckbox: true,
  })
  public type?: boolean;

  @column({
    label: 'Régions',
    isArray: true,
    nameDropDown: 'Liste des régions',
    name: 'name',
  })
  public regions: Array<Region> = [];

  static fromJSON(object: Region): DataUser {
    let dataUser = new DataUser();
    dataUser = Object.assign(dataUser, object);
    return dataUser;
  }
}
